export default __webpack_public_path__ + "static/media/web-form-en.3e003e23.png";